<template>
  <SACBottomSheet
    sheetClass="service-detail-sheet"
    cardClass="serv-detail-modal"
    :show="showServiceBottomSheet"
    :close="() => toggleServiceBottomSheet(false)"
  >
    <template
      v-if="serviceBottomsheetView === 'smart-lead'"
      #content
    >
      <SmartLeadDetail
        :smartLead="serviceInfo"
      />
    </template>
    <template
      v-else-if="serviceBottomsheetView === 'service-request'"
      #content
    >
      <ServiceDetail
        :sr="serviceInfo"
        :close="() => toggleServiceBottomSheet(false)"
      />
    </template>
  </SACBottomSheet>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import SACBottomSheet from '@shared/components/sac/SACBottomSheet.vue';
import SmartLeadDetail from './bottomsheet/SmartLeadDetail.vue';
import ServiceDetail from './bottomsheet/ServiceDetail.vue';

export default {
  name: 'ServiceDetailSheet',
  components: {
    SmartLeadDetail,
    SACBottomSheet,
    ServiceDetail,
  },
  mixins: [serviceMixin],
};
</script>

<style lang="scss">
.service-detail-sheet {
  margin-top: 64px;
  background-color: $BLACK;
  .serv-detail-modal {
    height: 84vh;
    width: 100%;
    padding: 0 100px 50px 100px;
    max-width: 1704px;
  }
  .modal-content {
    display: grid;
    grid-template-columns: 345px 1fr;
    height: 100%;
    background-color: $BLACK;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: relative;
    @media (max-width: 1149px) {
      grid-template-columns: 250px 1fr;
    }
    @media (max-width: 850px) {
      grid-template-columns: 200px 1fr;
    }
    .modal-close {
      position: absolute;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      display: grid;
      align-items: center;
      justify-content: center;
      background-color: $N80;
      top: 1.5rem;
      left: 1.5rem;
      z-index: 1;
      @media (max-width: 850px) {
        height: 24px;
        width: 24px;
        top: 16px;
        left: 16px;
      }
    }
  }
}
</style>
